export const config = {
  eventGroup: 'js4_gw_mo_20251120',
  name: '剑侠世界4无限官网MO端',
  identify: 'js4',
  eventTags: ['js4', 'mo', 'gw']
};

export default function createTracker(report, getDiffRouteTime) {
  return {
    loadPage: function() {
      report({
        eventName: 'load_page',
        eventDescription: '页面加载(默认上报，页面全部加载完才上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    pageLeave: function() {
      report({
        eventName: 'page_leave',
        eventDescription: '离开页面(默认上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    loadPageStart: function() {
      report({
        eventName: 'load_page_start',
        eventDescription: '页面加载(默认上报，进入页面就上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    /**
     * @param {string} [title] - 上报点击顶部通栏的板块：江湖快报、游戏特色、门派介绍、攻略资料、视听中心、关注我们-企微、关注我们-公众号、关注我们-微博、关注我们-抖音
     */
    clickTopNav: function(title) {
      report({
        eventName: 'click_top_nav',
        eventDescription: '点击顶部通栏',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报选中的系统：安卓、苹果、电脑、鸿蒙
     * @param {string} [status] - 成功：success 失败：fail
     * @param {string} [statusReason] - 返回原因
     */
    clickGoReserve: function(title, status, statusReason) {
      report({
        eventName: 'click_go_reserve',
        eventDescription: '点击前往预约',
        eventDataValue: {
          title: title,
          status: status,
          status_reason: statusReason
        },
        types: {
          title: checkTypeHOF('string'),
          status: checkTypeHOF('string'),
          status_reason: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报点击的位置：顶部通栏、首页（预约期）、首页（预下载期）
     */
    clickToReserveGame: function(title) {
      report({
        eventName: 'click_to_reserve_game',
        eventDescription: '点击立即预约',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 报选中的系统：安卓、苹果、电脑、鸿蒙
     */
    clickToDownload: function(title) {
      report({
        eventName: 'click_to_download',
        eventDescription: '点击下载游戏',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    clickGoRecharge: function() {
      report({
        eventName: 'click_go_recharge',
        eventDescription: '点击官方充值'
      });
    },
    /**
     * @param {string} [title] - 上报标题名称|字符串
     */
    clickJhkbLunbotu: function(title) {
      report({
        eventName: 'click_jhkb_lunbotu',
        eventDescription: '点击江湖快报轮播图',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报点击栏目：最新、新闻、公告、活动、更多
     */
    clickJhkbNav: function(title) {
      report({
        eventName: 'click_jhkb_nav',
        eventDescription: '点击江湖快报栏目',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报文章标题
     */
    clickJhkbDetails: function(title) {
      report({
        eventName: 'click_jhkb_details',
        eventDescription: '点击江湖快报栏目文章',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报门派名称
     */
    clickMenpai: function(title) {
      report({
        eventName: 'click_menpai',
        eventDescription: '点击门派介绍按钮',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 最新、新手、门派、玩法、进阶、更多
     */
    clickH5GlzlNav: function(title) {
      report({
        eventName: 'click_h5_glzl_nav',
        eventDescription: '点击攻略资料栏目',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报文章标题
     */
    clickGlzlDetails: function(title) {
      report({
        eventName: 'click_glzl_details',
        eventDescription: '点击攻略资料栏目文章',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报点击的栏目：视频、图像、音乐
     */
    clickStzxNav: function(title) {
      report({
        eventName: 'click_stzx_nav',
        eventDescription: '点击视听中心栏目',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    clickWeixin: function() {
      report({
        eventName: 'click_weixin',
        eventDescription: '点击微信公众号'
      });
    },
    clickQiwei: function() {
      report({
        eventName: 'click_qiwei',
        eventDescription: '点击企业微信'
      });
    },
    clickDouyin: function() {
      report({
        eventName: 'click_douyin',
        eventDescription: '点击官方抖音'
      });
    },
    clickWeibo: function() {
      report({
        eventName: 'click_weibo',
        eventDescription: '点击官方微博'
      });
    },
    /**
     * @param {string} [title] - 最新、新闻、公告、活动
     */
    clickJhkbNavInner: function(title) {
      report({
        eventName: 'click_jhkb_nav_inner',
        eventDescription: '点击江湖快报内页栏目',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报文章标题
     */
    clickJhkbDetailsInner: function(title) {
      report({
        eventName: 'click_jhkb_details_inner',
        eventDescription: '点击江湖快讯内页栏目文章',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报搜索的关键词
     */
    clickSearch: function(title) {
      report({
        eventName: 'click_search',
        eventDescription: '点击搜索',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报点击的栏目：最新、新手、门派、玩法、进阶
     */
    clickGlzlNavInner: function(title) {
      report({
        eventName: 'click_glzl_nav_inner',
        eventDescription: '点击攻略资料内页栏目',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报文章标题
     */
    clickGlzlDetailsInner: function(title) {
      report({
        eventName: 'click_glzl_details_inner',
        eventDescription: '攻略资料内页栏目文章',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报图片标题
     */
    clickStzxPicture: function(title) {
      report({
        eventName: 'click_stzx_picture',
        eventDescription: '点击视听中心图片',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报点击的音乐的标题
     */
    clickStzxMusic: function(title) {
      report({
        eventName: 'click_stzx_music',
        eventDescription: '点击视听中心音乐',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报播放的音乐标题
     */
    clickStzxPlayMusic: function(title) {
      report({
        eventName: 'click_stzx_play_music',
        eventDescription: '点击播放视听中心音乐',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报点击的视频标题
     */
    clickStzxVideo: function(title) {
      report({
        eventName: 'click_stzx_video',
        eventDescription: '点击视听中心视频',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报播放的视频标题
     */
    clickStzxPlayVideo: function(title) {
      report({
        eventName: 'click_stzx_play_video',
        eventDescription: '点击播放视听中心视频',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报游戏特色标题
     */
    clickYxts: function(title) {
      report({
        eventName: 'click_yxts',
        eventDescription: '点击游戏特色',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    clickKvVideo: function() {
      report({
        eventName: 'click_kv_video',
        eventDescription: '点击KV视频按钮'
      });
    }
  };
}

Number.isInteger =
  Number.isInteger ||
  function(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };

function checkTypeHOF(type) {
  switch (type) {
    case 'int':
      return Number.isInteger;
    case 'float':
      return value => typeof value === 'number' && !Number.isInteger(value);
    case 'boolean':
      return value => typeof value === 'boolean';
    case 'string':
      return value => typeof value === 'string';
    default:
      setTimeout(() => {
        throw new Error('st-report: invalid value type = ' + type);
      }, 0);
      return null;
  }
}
